/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 11:25:49
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 11:35:41
 * @name: 工单管理-待审核列表
 * @Description: 工单管理-待审核列表
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\getNeedVerifyList.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'type',
    description: '类型 all所有(默认) todo待审核 finish已审核',
    required: true,
    required_message: '类型为必传项',
    match: (e) => {
      if (!['all', 'todo', 'finish'].includes(e)) {
        return 'type须为all、todo或finish';
      } else {
        return '';
      }
    }
  },
  {
    key: 'piano_no',
    description: '琴号',
    required: false,
    match: (e) => {
      return '';
    }
  },
]